<template>
  <div class="confirm-modal">
    <div class="confirm-modal__header">
      <div class="confirm-modal__title">{{ title }}</div>
    </div>

    <div v-if="subtitle" class="confirm-modal__subtitle">
      {{ subtitle }}
    </div>

    <div class="confirm-modal__footer">
      <button class="confirm-modal__button confirm-modal__button_cancel"
              @click.prevent="close(false)">{{ noText }}</button>
      <button class="confirm-modal__button confirm-modal__button_delete"
              :style="{ 'background-color': yesBtnColor }"
              @click.prevent="close(true)">{{ yesText }}</button>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'

export default {
  name: 'BaseConfirmModal',
  mixins: [BaseModalMixins],
  props: {
    title: {
      type: String,
      default: 'Are you sure?'
    },
    yesText: {
      type: String,
      default: 'Yes'
    },
    noText: {
      type: String,
      default: 'No'
    },
    subtitle: {
      type: String,
      default: null
    },
    yesBtnColor: {
      type: String,
      default: '$rfx-red'
    }
  },
  methods: {
    close (status = false) {
      this.$emit('confirm', status)
    }
  }
}
</script>

<style scoped lang="scss">
  .confirm-modal {
    padding: 40px;
    box-shadow: 0 16px 32px 0 rgba(1, 22, 39, 0.5);

    &__subtitle {
      margin-top: 16px;
      font-family: Roboto;
      text-align: center;
      font-size: 14px;
      color: $rfx-red;
    }

    &__title {
      text-align: center;
      font-size: 24px;
      line-height: 32px;
      color: $rfx-dark-march;
      font-weight: bold;
      letter-spacing: -0.24px;
    }

    &__footer {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    &__button {
      min-width: 100px;
      padding: 0 25px;
      height: 40px;
      font-size: 10px;
      font-weight: 900;
      cursor: pointer;
      text-transform: uppercase;
      border-radius: 8px;
      outline: none;
      border: none;

      &_cancel {
        color: $rfx-dark-march;
        background-color: transparent;
        margin-right: 15px;
      }

      //&_add {
      //  color: #fff;
      //  background-color: $rfx-dark-march;
      //  margin-left: 15px;
      //}

      &_delete {
        color: #fff;
        background-color: $rfx-red;
        margin: 0 15px;
      }
    }
  }
</style>
